import { c as _c } from "react/compiler-runtime";
import { mergeClasses } from '@/utils/style';
import React, { PropsWithChildren } from 'react';
export function Header(t0) {
  const $ = _c(5);
  const {
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = mergeClasses("mb-3 text-2xl font-bold lg:mb-4", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <h2 className={t1}>{children}</h2>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
export function SubHeader(t0) {
  const $ = _c(5);
  const {
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = mergeClasses("mt-6 mb-1 text-base font-semibold lg:mt-8 lg:text-xl", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <h3 className={t1}>{children}</h3>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
export function MinorHeader(t0) {
  const $ = _c(5);
  const {
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = mergeClasses("mt-4 mb-1 text-base font-semibold lg:mt-5 lg:mb-2", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <h4 className={t1}>{children}</h4>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}